// src/templates/ModelosBotoes.js

export const botoesGrunge = [

/* =====================================
    🎨 PINCELADAS (BRUSH STROKES)
===================================== */

{
  id: "brush-yellow",
  nome: "Pincelada Amarela",
  tipo: "texto",
  conteudo: "TRADICIONAIS",
  estilo: {
    fontSize: 28, color: "#000", fontWeight: "900", fontFamily: "Oswald",
    backgroundColor: "#ffb800", padding: "20px 80px", display: "inline-block",
    WebkitMaskImage: "url('/assets/brush-mask.png')",
    maskImage: "url('/assets/brush-mask.png')",
    WebkitMaskSize: "100% 100%", maskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

{
  id: "brush-red",
  nome: "Pincelada Vermelha",
  tipo: "texto",
  conteudo: "OFERTAS",
  estilo: {
    fontSize: 28, color: "#fff", fontWeight: "900", fontFamily: "Oswald",
    backgroundColor: "#e53935", padding: "20px 80px", display: "inline-block",
    WebkitMaskImage: "url('/assets/brush-mask.png')",
    maskImage: "url('/assets/brush-mask.png')",
    WebkitMaskSize: "100% 100%", maskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

{
  id: "brush-green",
  nome: "Pincelada Verde",
  tipo: "texto",
  conteudo: "SALADAS",
  estilo: {
    fontSize: 26, color: "#fff", fontWeight: "bold", fontFamily: "Oswald",
    backgroundColor: "#2ecc71", padding: "20px 70px", display: "inline-block",
    WebkitMaskImage: "url('/assets/brush-mask.png')",
    maskImage: "url('/assets/brush-mask.png')",
    WebkitMaskSize: "100% 100%", maskSize: "100% 100%",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

{
  id: "brush-blue",
  nome: "Pincelada Azul",
  tipo: "texto",
  conteudo: "DRINKS",
  estilo: {
    fontSize: 26, color: "#fff", fontWeight: "bold", fontFamily: "Oswald",
    backgroundColor: "#3498db", padding: "20px 70px", display: "inline-block",
    WebkitMaskImage: "url('/assets/brush-mask.png')",
    maskImage: "url('/assets/brush-mask.png')",
    WebkitMaskSize: "100% 100%", maskSize: "100% 100%",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

{
  id: "brush-orange",
  nome: "Pincelada Laranja",
  tipo: "texto",
  conteudo: "LANCHES",
  estilo: {
    fontSize: 26, color: "#fff", fontWeight: "bold", fontFamily: "Oswald",
    backgroundColor: "#e67e22", padding: "20px 70px", display: "inline-block",
    WebkitMaskImage: "url('/assets/brush-mask.png')",
    maskImage: "url('/assets/brush-mask.png')",
    WebkitMaskSize: "100% 100%", maskSize: "100% 100%",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

{
  id: "brush-purple",
  nome: "Pincelada Roxa",
  tipo: "texto",
  conteudo: "SOBREMESAS",
  estilo: {
    fontSize: 26, color: "#fff", fontWeight: "bold", fontFamily: "Oswald",
    backgroundColor: "#9b59b6", padding: "20px 70px", display: "inline-block",
    WebkitMaskImage: "url('/assets/brush-mask.png')",
    maskImage: "url('/assets/brush-mask.png')",
    WebkitMaskSize: "100% 100%", maskSize: "100% 100%",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

/* =====================================
    🔥 PROMOÇÕES
===================================== */

{
  id: "promo-red",
  nome: "Promoção Vermelha",
  tipo: "texto",
  conteudo: "PROMOÇÃO",
  estilo: {
    fontSize: 24, color: "#fff", fontWeight: "900", fontFamily: "Montserrat",
    backgroundColor: "#ff0000", padding: "12px 45px", display: "inline-block",
    borderRadius: "8px", boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

{
  id: "promo-fire",
  nome: "Promoção Explosão",
  tipo: "texto",
  conteudo: "SUPER PROMO",
  estilo: {
    fontSize: 24, color: "#fff", fontWeight: "900", fontFamily: "Oswald",
    backgroundColor: "#ff5722", padding: "14px 50px", display: "inline-block",
    transform: "skew(-10deg)", // Mantendo o efeito original
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

/* =====================================
    🍔 HAMBURGUERIA & 🍕 PIZZARIA
===================================== */

{
  id: "burger-black",
  nome: "Burger Black",
  tipo: "texto",
  conteudo: "SMASH",
  estilo: {
    fontSize: 24, color: "#fff", fontWeight: "bold", fontFamily: "Oswald",
    backgroundColor: "#000", padding: "12px 40px", borderRadius: "20px",
    display: "inline-block", rotate: 0, scaleX: 1, scaleY: 1
  }
},

{
  id: "pizza-premium",
  nome: "Pizza Premium",
  tipo: "texto",
  conteudo: "PREMIUM",
  estilo: {
    fontSize: 22, color: "#f1c40f", fontWeight: "bold", fontFamily: "Playfair Display",
    backgroundColor: "#000", padding: "12px 40px", display: "inline-block",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

/* =====================================
    ✨ NEON
===================================== */

{
  id: "neon-blue",
  nome: "Neon Azul",
  tipo: "texto",
  conteudo: "DRINKS",
  estilo: {
    fontSize: 24, color: "#00d2ff", fontWeight: "bold", fontFamily: "Montserrat",
    padding: "10px 30px", border: "2px solid #00d2ff", display: "inline-block",
    textShadow: "0 0 10px #00d2ff", boxShadow: "0 0 20px #00d2ff",
    rotate: 0, scaleX: 1, scaleY: 1
  }
},

/* =====================================
    🧱 MODERN
===================================== */

{
  id: "modern-dark",
  nome: "Modern Dark",
  tipo: "texto",
  conteudo: "PREMIUM",
  estilo: {
    fontSize: 22, color: "#fff", fontWeight: "bold", fontFamily: "Inter",
    backgroundColor: "#111", padding: "12px 40px", borderLeft: "8px solid #ffb800",
    display: "inline-block", rotate: 0, scaleX: 1, scaleY: 1
  }
}

];